import { TenantBaseApi } from "api/TenantSlug/TenantBaseApi";

import GetBalanceRequest = App.Http.Requests.Balance.GetBalanceRequest;
import GetBalancesRequest = App.Http.Requests.Balance.GetBalancesRequest;
import GetBalanceTotalsRequest = App.Http.Requests.Balance.GetBalanceTotalsRequest;
import GetBalanceResponse = App.Http.Responses.Balance.GetBalanceResponse;
import GetBalancesResponse = App.Http.Responses.Balance.GetBalancesResponse;
import GetBalanceTotalsResponse = App.Http.Responses.Balance.GetBalanceTotalsResponse;
import GetBalanceWalletResponse = App.Http.Responses.Balance.GetBalanceWalletResponse;

class BalanceApi extends TenantBaseApi {
    /**
     * Get a specific balance by ID
     *
     * - Request: GetBalanceRequest
     * - Response: GetBalanceResponse
     */
    async show(requestId: string, request: GetBalanceRequest): Promise<GetBalanceResponse> {
        return await this.get<GetBalanceResponse, GetBalanceRequest>(`/balances/${requestId}`, {
            params: request,
        });
    }

    /**
     * Get list of balances
     *
     * - Request: GetBalancesRequest
     * - Response: GetBalancesResponse
     */
    async index(request: GetBalancesRequest): Promise<GetBalancesResponse> {
        return await this.get<GetBalancesResponse, GetBalancesRequest>("/balances", {
            params: request,
        });
    }

    /**
     * Get the wallet summary (one entry per role, with per-currency breakdown)
     *
     * - Response: GetBalanceWalletResponse
     */
    async wallet(): Promise<GetBalanceWalletResponse> {
        return await this.get<GetBalanceWalletResponse, undefined>("/balances/wallet");
    }

    /**
     * Get totals for a role, broken down per currency
     *
     * - Request: GetBalanceTotalsRequest
     * - Response: GetBalanceTotalsResponse
     */
    async totals(request: GetBalanceTotalsRequest): Promise<GetBalanceTotalsResponse> {
        return await this.get<GetBalanceTotalsResponse, GetBalanceTotalsRequest>("/balances/totals", {
            params: request,
        });
    }
}

export const balanceApi = new BalanceApi();
